import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  TextField,
} from '@mui/material';

export default function SessionAppointmentDetailDialog({
  open,
  session,
  onClose,
  onApprove,
  onDecline,
  onReschedule,
}) {
  const [sessionDate, setSessionDate] = useState('');
  const [startTime, setStartTime] = useState('');
  const [endTime, setEndTime] = useState('');
  const [isEditing, setIsEditing] = useState(false);

  console.log('SessionAppointmentDetailDialog session:', session);

  //   useEffect(() => {
  //     if (session) {
  //       setSessionDate(session.sessionDate?.slice(0, 10));
  //       setStartTime(session.startTime);
  //       setEndTime(session.endTime);
  //       setIsEditing(false); // reset every time dialog opens
  //     }
  //   }, [session]);

  useEffect(() => {
    if (session) {
      setSessionDate(session.sessionDate ? session.sessionDate.slice(0, 10) : '');

      setStartTime(session.startTime ?? '');
      setEndTime(session.endTime ?? '');

      setIsEditing(false);
    }
  }, [session]);

  if (!session) return null;

  const handleStartReschedule = () => {
    setIsEditing(true); // enable fields
  };

  const handleSaveReschedule = () => {
    onReschedule({
      ...session,
      sessionDate,
      startTime,
      endTime,
    });
    setIsEditing(false);
  };

  const handleCancelEdit = () => {
    // revert values
    setSessionDate(session.sessionDate?.slice(0, 10));
    setStartTime(session.startTime);
    setEndTime(session.endTime);
    setIsEditing(false);
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Session Details</DialogTitle>

      <DialogContent>
        <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Typography>
            <strong>Patient:</strong> {session.patientName || session.patientId?.name || 'N/A'}
          </Typography>

          <Typography>
            <strong>Session No:</strong> {session.sessionNo}
          </Typography>

          <TextField
            label="Date"
            type="date"
            value={sessionDate}
            disabled={!isEditing} // ⭐ disabled unless rescheduling
            onChange={(e) => setSessionDate(e.target.value)}
            InputLabelProps={{ shrink: true }}
          />
          <TextField
            label="Start Time"
            type="time"
            value={startTime}
            disabled={!isEditing}
            onChange={(e) => setStartTime(e.target.value)}
            InputLabelProps={{ shrink: true }}
          />

          <TextField
            label="End Time"
            type="time"
            value={endTime}
            disabled={!isEditing}
            onChange={(e) => setEndTime(e.target.value)}
            InputLabelProps={{ shrink: true }}
          />

          {/* <TextField
            label="Start Time"
            type="time"
            value={startTime}
            disabled={!isEditing}
            onChange={(e) => setStartTime(e.target.value)}
            InputLabelProps={{ shrink: true }}
          />

          <TextField
            label="End Time"
            type="time"
            value={endTime}
            disabled={!isEditing}
            onChange={(e) => setEndTime(e.target.value)}
            InputLabelProps={{ shrink: true }}
          /> */}
        </Box>
      </DialogContent>

      <DialogActions>
        {!isEditing ? (
          <>
            <Button color="success" variant="contained" onClick={() => onApprove(session)}>
              Approve
            </Button>

            <Button color="error" variant="contained" onClick={() => onDecline(session)}>
              Decline
            </Button>

            <Button color="warning" variant="contained" onClick={handleStartReschedule}>
              Reschedule
            </Button>
          </>
        ) : (
          <>
            <Button color="primary" variant="contained" onClick={handleSaveReschedule}>
              Save Reschedule
            </Button>

            <Button onClick={handleCancelEdit}>Cancel</Button>
          </>
        )}

        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}
